<div class="bg-surface-900 p-12 lg:p-20">
    <div class="container mx-auto flex flex-wrap lg:flex-row flex-col-reverse gap-12 items-center">
        <div class="flex-1 text-center my-12 relative">
            <div class="text-6xl text-white font-bold mb-1 leading-tight">
                Welcome to
            </div>

            <div class="text-6xl text-primary-400 font-bold mb-6 leading-tight">
                {{ appName }} Admin
            </div>

            <p class="mt-0 mb-6 leading-normal text-center mx-auto text-white max-w-2xl text-xl">
                {{ appDesc }}
            </p>

            <button
            pButton
            type="button"
            class="me-2"
            [outlined]="true"
            (click)="redirectToMarketing();">
                <span pButtonLabel>Learn More</span>
            </button>

            <button
            pButton
            type="button"
            (click)="signIn();">
                <span pButtonLabel>Sign In</span>
                <i class="pi pi-sign-in ms-1"></i>
            </button>

            <p class="mt-6 mb-6 leading-normal text-white">Available for Android, iOS, and Web.</p>
            <div class="flex justify-center items-center gap-8">
                <a
                class="text-white"
                href="https://play.google.com/store/apps"
                target="_blank">
                    <i class="pi pi-android text-4xl!"></i>
                </a>

                <a
                class="text-white"
                href="https://www.apple.com/app-store"
                target="_blank">
                    <i class="pi pi-apple text-4xl!"></i>
                </a>

                <a
                class="text-white"
                target="_blank">
                    <i class="pi pi-code text-4xl!"></i>
                </a>
            </div>
        </div>

        <div class="flex-1 text-center lg:text-right overflow-hidden">
            <img src="https://fqjltiegiezfetthbags.supabase.co/storage/v1/render/image/public/block.images/blocks/hero/Illustrations.svg" alt="Image" class="w-full max-w-md lg:w-auto lg:max-w-xl mx-auto" />
        </div>
    </div>
</div>

<!-- <div class="bg-surface-0 dark:bg-surface-950 px-6 md:px-12 lg:px-20 py-20 text-center">
    <div class="container mx-auto flex flex-col gap-6">
        <div class="flex flex-col items-center gap-4">
            <div class="font-bold text-3xl leading-tight">
                <span class="text-surface-900 dark:text-surface-0">One Product</span>
                <br />
                <span class="text-primary-500 dark:text-primary-400">Many Solutions</span>
            </div>

            <div class="text-surface-500 dark:text-surface-400 leading-tight">
                Ac turpis egestas maecenas pharetra convallis posuere morbi leo urna.
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4">
            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-users text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.contactManager.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.contactManager.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-calendar text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.eventManager.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.eventManager.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-clock text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.reservationManager.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.reservationManager.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-user-edit text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.membershipManager.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.membershipManager.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-mobile text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.credentials.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.credentials.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-car text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.transportation.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.transportation.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-building text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.accommodations.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.accommodations.description }}
                    </p>
                </div>
            </div>

            <div class="w-full rounded-md p-4">
                <span class="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-surface-0 dark:bg-surface-800 shadow mx-auto">
                    <i class="pi pi-list text-2xl! lg:text-3xl! text-primary-500 dark:text-primary-400"></i>
                </span>

                <div class="flex flex-col gap-1">
                    <div class="text-surface-900 dark:text-surface-0 text-xl font-medium leading-tight">
                        {{ features.stringer.name }}
                    </div>

                    <p class="text-surface-500 dark:text-surface-400 leading-normal">
                        {{ features.stringer.description }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-demo-call-to-action></app-demo-call-to-action>

<!-- 
<app-public-content>
    <div class="bg-surface-0 dark:bg-surface-900 px-6 py-20 md:px-12 lg:px-20">
        <div class="flex lg:flex-row flex-col gap-16 xl:gap-32 py-16 px-8 lg:p-8 xl:p-12 bg-surface-50 dark:bg-surface-900 border border-surface-200 dark:border-surface-800 rounded-2xl text-center lg:text-left">
            <div class="flex-1 flex flex-col justify-center">
                <h2 class="text-3xl block text-primary-900 dark:text-primary-50 font-bold mb-4 leading-tight">Get Deals and Updates</h2>
                <p class="block text-lg text-primary-600 dark:text-primary-400 font-medium mb-8 leading-normal">We promise for not sending spam emails. It'll only good emails.</p>
                <div class="container mx-auto bg-surface-0/90 dark:bg-surface-800/90 w-full border border-primary-100 dark:border-primary-700 rounded-full pl-4 py-2 pr-2 flex items-center gap-4">
                    <input
                        class="flex-1 w-full bg-transparent outline-hidden text-surface-900 dark:text-surface-0 placeholder:text-surface-600 dark:placeholder:text-surface-400 text-base border-none"
                        placeholder="Email"
                    />
                    <button pButton [rounded]="true" class="w-fit shrink-0 px-3! py-2! text-base! font-medium!">
                        <span pButtonLabel>Subscribe</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</app-public-content> -->
